import React, { Fragment } from "react";
import diagram from "../../assets/aspreactapp_diagram.jpg";
import { Label, Image } from "semantic-ui-react";

const Diagram = () => {
  return (
    <Fragment>
      <Label ribbon>Diagram of the AspReactApp Project</Label>
      <Image centered fluid src={diagram} size="huge" style={{width: '60%'}}/>
    </Fragment>
  );
};

export default Diagram;
